export const NOTIFICATION_RIBBON_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.RibbonNotificationElement';
export const NOTIFICATION_TOOLTIP_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.TooltipNotificationElement';
